import { createAction } from '@ngrx/store';

const loadHqProfessionalViews = createAction('[HqProfessional Effect] Load headquarter professional views');

export const HqProfessionalListActions = {
  loadHqProfessionalViews,
};
